module.exports = "## Build Modern Products Faster\n\nMineral UI is an open-source design system created to simplify building\nappealing, modern software experiences. It is the culmination of designers and\ndevelopers working together to give teams the ability to ship high-quality\nproducts faster.\n\n<CallsToAction />\n"


//////////////////
// WEBPACK FOOTER
// ./src/website/app/pages/Home/content/intro.md
// module id = 513
// module chunks = 9